import { render, staticRenderFns } from "./testingPointDes.vue?vue&type=template&id=e7b62bb2&scoped=true&"
import script from "./testingPointDes.vue?vue&type=script&lang=ts&"
export * from "./testingPointDes.vue?vue&type=script&lang=ts&"
import style0 from "./testingPointDes.vue?vue&type=style&index=0&id=e7b62bb2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b62bb2",
  null
  
)

export default component.exports